import { Grid, Heading } from '@simplywallst/ui-core';

export const EmptyState = () => {
  return (
    <Grid gap="24px" gapMd="16px" placeItems="center" placeContent="center">
      <Heading
        as="h3"
        color="spaceGray"
        textAlign="center"
        typography="smallStrong"
      >
        Can't find your company/ticker
      </Heading>
    </Grid>
  );
};
